import React, {useEffect, useId, useState} from "react";
import "./index.scss";

const SHIELD = "M10 1 19 4v7c0 6-4 10-9 12C5 21 1 17 1 11V4Z";

// Stemma del club: immagine originale, altrimenti mini bandierina con i colori sociali,
// altrimenti scudo neutro. Mai sigle generate.
const ClubCrest = (props) => {
	const {name, logoUrl, colors = [], size = 24} = props;
	const clipId = useId();
	const [broken, setBroken] = useState(false);
	useEffect(() => setBroken(false), [logoUrl]);
	const [first, second = first] = (Array.isArray(colors) ? colors : []).filter(
		Boolean,
	);
	const variant = logoUrl && !broken ? "logo" : first ? "flag" : "placeholder";
	const label = name || "Club";

	return (
		<span
			className="club-crest"
			style={{width: size, height: size}}
			role={variant === "logo" ? undefined : "img"}
			aria-label={variant === "logo" ? undefined : label}
			title={name}
			data-variant={variant}
		>
			{variant === "logo" ? (
				<img src={logoUrl} alt={label} onError={() => setBroken(true)} />
			) : (
				<svg viewBox="0 0 20 24" aria-hidden="true">
					{variant === "flag" ? (
						<>
							<clipPath id={clipId}>
								<path d={SHIELD} />
							</clipPath>
							<g clipPath={`url(#${clipId})`}>
								<rect width="10" height="24" fill={first} />
								<rect x="10" width="10" height="24" fill={second} />
							</g>
							<path d={SHIELD} className="club-crest__outline" />
						</>
					) : (
						<path d={SHIELD} className="club-crest__placeholder" />
					)}
				</svg>
			)}
		</span>
	);
};

export default ClubCrest;
